export default function UpdatePriceSlider(min, max, currMin, currMax) {
  var keypressSlider = document.getElementById('keypress');
  keypressSlider.noUiSlider.updateOptions({
    range: {
      'min': min,
      'max': max
    },
    start: [currMin, currMax]
  });
}